<template>
  <v-list dense three-line class="transparent">
    <template v-for="email in emails">
      <v-list-item :key="`list-${email.id}`" class="list__tile--free-height">
        <v-list-item-content>
          <v-list-item-title v-if="email.properties.message_data.msg">
            {{ email.properties.message_data.msg.email }}
          </v-list-item-title>
          <v-list-item-content class="text--primary">{{ email.description }}</v-list-item-content>
          <v-list-item-subtitle>{{ email.properties.email }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="email.properties.message_data.msg">
            <v-chip color="accent darken-1" text-color="white" label small class="ml-0">
              <strong>Status:</strong>&nbsp;{{ email.properties.message_data.msg.state }}
            </v-chip>
            <v-chip color="accent" text-color="white" label small>
              <strong>Opens:</strong>&nbsp;
              <span v-if="email.properties.message_data.msg.opens">
                {{ email.properties.message_data.msg.opens.length }}
              </span>
              <span v-else> 0</span>
            </v-chip>
            <v-chip color="accent lighten-1" text-color="white" label small>
              <strong>Clicks:</strong>&nbsp;
              <span v-if="email.properties.message_data.msg.clicks">
                {{ email.properties.message_data.msg.clicks.length }}
              </span>
              <span v-else> 0</span>
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text>{{ email.created_at | moment('calendar') }}</v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
      <v-divider :key="`divider-${email.id}`"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'email-list',
  props: ['emails']
};
</script>

<style lang="scss" scoped>
.list__tile--free-height {
  ::v-deep .list__tile {
    height: auto;
    min-height: 76px;
    padding: {
      top: 5px;
      bottom: 5px;
    }
    align-items: flex-start;
  }
}

::v-deep .list__tile__sub-title {
  -webkit-line-clamp: unset;
}
</style>
